








































































































import OnsiteSearchProductResultItem from './OnsiteSearchProductResultItem.vue';
import OnsiteSearchGroup from './OnsiteSearchGroup.vue'
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "OnsiteSearchResult",
    components: {
        OnsiteSearchProductResultItem,
        OnsiteSearchGroup
    },
    props: {
    },
    data() {
        return {
            groupId: '',
            onScrollActiveted: false,
            intersectionObserver: null
        }
    },
    computed: mapGetters(['getTranslations', 'getQueryString', 'getProductResults', 'getTotalResults', 'getProductTotalResults', 'getGroups', 'getAllTabStatus']),
    methods: {
        ...mapActions(['getProducts']),
        getMoreProducts() {
            this.onScrollActiveted = true
            this.groupId = 'products'
            this.$store.dispatch("setSelectedTab", 'products')
            this.getProducts()
        },
        getGroupIdfromTab(e: { target: { dataset: { groupId: string; }; }; }) {
            this.onScrollActiveted = true
            this.groupId = e.target.dataset.groupId
            this.$store.dispatch("setSelectedTab", e.target.dataset.groupId)
            this.initScrollEventListener(e.target.dataset.groupId)
        },
        addScrollEventListener() {
            const scrollSentinel = document.querySelector('.mdl-onsite-search-scroll-sentinel')
            
            if (!scrollSentinel)
                return
                
            this.intersectionObserver = new IntersectionObserver( e => {
                const isIntersecting = e[0]?.isIntersecting ?? false
                
                if (isIntersecting) {
                    this.loadMoreProducts()
                }
            });

            this.intersectionObserver.observe(scrollSentinel)
        },
        removeIntersectionObserver() {
            if (this.intersectionObserver) {
                this.intersectionObserver.disconnect();
                this.intersectionObserver = null;
            }
        },
        loadMoreProducts() {
            if (!this.onScrollActiveted || this.groupId === 'all')
                return
            
            if (this.groupId == 'products') {
                this.getProducts()
            } else {
                const group = this.getGroups.find((group) => group.id === this.groupId)
                
                if (group.web20ResultsLoaded < group.web20TotalResults) {
                    this.$store.dispatch("getGroupContent", this.groupId)
                }
            }

            setTimeout(() => {
                const group = this.getGroups.find((group) => group.id === this.groupId)

                if(group) {
                    if(!group.results) return

                    if ((group.results.length < group.totalResults) && (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight)) {
                        const list = document.querySelector(`[data-tab="${group.name.toLowerCase()}"] .mdl-onsite-search__result-list`) as HTMLElement
                        
                        if (list.children.length > 20) list.children[list.children.length-20].scrollIntoView()
                    }
                }
                if(this.groupId === 'products') {
                    if ((this.getProductResults.length < this.getProductTotalResults) && (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight)) {
                        const list = document.querySelector(`[data-tab="products"] .mdl-onsite-search__result-list`) as HTMLElement
                        
                        if (list.children.length > 20) list.children[list.children.length-20].scrollIntoView()
                    }
                }
            },750)
            
        },
        removeScrollEvent(e: { target: { dataset: { groupId: string; }; }; }){
            this.removeIntersectionObserver()
            this.onScrollActiveted = false
            this.$store.dispatch("setSelectedTab", e.target.dataset.groupId)
        },
        initMobileTabs() {
            const mobileTabs = document.querySelectorAll('.obj-tab-navigation__compact-overlay-option') as NodeList 
        
            if (!mobileTabs) 
                return

            mobileTabs.forEach(tab => {
                tab.addEventListener('click', this.setGroupIdFromMobileTab)
            });
        },
        setGroupIdFromMobileTab(e: any) {
            if(e) {
                const groupName = e.composedPath()[1].childNodes[0].defaultValue.toLowerCase()

                if (groupName.length === 0)
                    return
                
                if (groupName === 'products') {
                    this.groupId = groupName
                    return
                }
                    
                const group = this.getGroups.find((group) => group.name.toLowerCase() === groupName)
                
                if (!group)
                    return

                this.groupId = group.id
            }
        },
        initScrollEventListener(groupId: string) {
            this.groupId = groupId
            setTimeout(() => {
                this.onScrollActiveted = true
            
                if(!this.intersectionObserver) {
                    this.addScrollEventListener()
                    this.initMobileTabs()
                }
            
            }, 1500);
        }
        
    },
    updated() {
        const slideLink = document.querySelector('.obj-tab-navigation__slide.active > a') as HTMLElement
        this.groupId = slideLink.dataset.groupId
        this.onScrollActiveted = true
        
        if(!this.intersectionObserver) {
            this.addScrollEventListener()
            this.initMobileTabs()
        }
    },
    mounted() {
        const slideLink = document.querySelector('.obj-tab-navigation__slide.active > a') as HTMLElement
        this.$store.dispatch("setSelectedTab", slideLink.dataset.groupId)
    }
}
